import React, { useState, useEffect, useRef } from "react";
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css'
import "./service.css";
import { useAlert } from 'react-alert' 
import { Tooltip } from 'react-bootstrap';
import { OverlayTrigger } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import axios from "axios";
import { APIURL } from "../../Global";
import { SOCKETURL } from "../../Global";
import { useNavigate, Navigate, Link } from "react-router-dom";
import EditRemark from "./EditRemark";
import AddRemark from "./AddRemark";
import LoadingOverlay from "react-loading-overlay";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import ViewRemark from "./ViewRemark";
import ViewInteractions from "./ViewInteractions";
import moment from 'moment';
import DispenceAdd from "./DispenceAdd";
import { IoClose } from "react-icons/io5";
function Medicines (props){
    const alert = useAlert()
console.log("props",props)
  let approve="approved";
  let reject ="rejected";
  var Typeahead = require("react-bootstrap-typeahead").Typeahead;
  const [reRender, setRerender] = useState(false);
  const [search, setSearch] = useState("");

  const [assignId, setAssignId] = useState(0);
  const [options, setOptions] = useState([]);
  const [hasNext, setHasNext] = useState(false)
  const [loading, setLoading] = useState(false);
  const [approved, setApprove] = useState(false);
  const [rejected, setReject] = useState(false);

  const [render, setRender] = useState(true);
  const [currentIndex, setCurrentIndex] = useState("");
  const [intakeValue, setIntakeValue] = useState("");
  const [, setCurrentColumn] = useState("");
  const [display, setDisplay] = useState(false);

  const [infoShow1, setinfoShow1] = useState(false);

  const [infoData1, setInfoData1] = useState("");
  const [remarkData, setRemarkData]= useState('')
  const [remarkData1, setRemarkData1]= useState([])
  const [viewShow, setViewShow]= useState(false)

  const [, setGetError] = useState('');
  const [tableData, setTableData] = useState([]);
  const [medData, setMedData] = useState([]);
  const pageSize = 10;
  const [options1, setOptions1] = useState([]);
  const [displayIndex, setDisplayIndex] = useState(null);
  const [selectedAssignees, setSelectedAssignees] = useState({})
  const [modalShow, setModalShow] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");
  const [remarkList, setRemarkList] = useState([])
  const [backup, setBackup] = useState('')
 const [dispenceCount,setDispenceCount] = useState("");
 const [dispenceID,setDispenceID] = useState("");
 const[dispenseShow,setDispenseShow] = useState(false);
  const [submitMsg, setSubmitMsg] = useState("");

  const [errorSubmit, setErrorSubmit] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [totalRows1, setTotalRows1] = useState(0);
  const[page,setPage]=useState(1)
  const [editShow, setEditShow] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false)

  const [cell, setCell] = useState('')
 
 
  const [id, setId] = useState("");
 
  const [patient, setpatient] = useState("");
  const [order, setOrder] = useState("")
  const [trackId, setTrackingId] = useState()
 
  const [changed, setChanged] = useState()
  const [keys,] = useState({ 'p': false, 'a': false, 'n': false, 'm': false, 'l': false });
 
  let tableData2=[]
  const currentDate = new Date();
  const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  const formattedTime = `${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;
  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var sendData = null

  function handleSend(childData) {
    sendData = childData
    
  }
  
  
 
    const CustomHeader = () => {
    return (
      <div>
        <span>Interactions</span>
        <i
          style={{ color: "black", marginLeft: "5px", cursor: "pointer" }}
          className="fa fa-exclamation-triangle fa-lg"
          aria-hidden="true"
        ></i>
      </div>
    );
  };

  const saveChangesMed = (index) => {

    setApprove(true);
    const rowToUpdate = medData.filter((elt, i) => {
      return i === index
    })

    callSaveMed(rowToUpdate[0],index);

  }
  useEffect(() => {
    
    setMedData(medData)
    // console.log(medData)
  }, [reRender, medData]);

  useEffect(() => {
    console.log(options);
    const xdata = options1;
    
    let filteredData = xdata.length > 0 && xdata.filter(x => {
        return x.name.toLowerCase().includes(search.toLowerCase());
    });
    
    setOptions(filteredData);
    console.log("filteredData", filteredData); // Log the object directly
}, [search]);

  const handleCloseDispence =()=>{
    setDispenseShow(false);
  setMedData([])
  setRerender(!reRender)
  setBackup('')
   // window.location.reload(false)
   
  }


  const callSave1Med = (rowToUpdate,index) => {
   
  
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '');
   // const id = rowToUpdate.id;
  
  
   const dataToUpdate = {
    status: reject
  };
  
  if (assignId) {
    dataToUpdate.assigned_to = assignId;
  }
  
  
  

    axios.put(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/${rowToUpdate.id}/`, dataToUpdate, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res => {

        if (res.data.status === "success") {
        
          alert.success("Rejected successfully");
          setSearch("")
          setAssignId(0)
          setSelectedAssignees({})
          setMedData([]);
          setRerender(!reRender);
          // setSubmitMsg(res.data.message ? res.data.message : "Updated successfully!");

          // setSuccessSubmit(true);
          setBackup('')
        }
        else {


          setErrorMsg(res.data.message ? res.data.message : "Error in submission");
          setErrorSubmit(true);

        }



      })
      .catch(err => {

        setErrorMsg("Error in submission");
        setErrorSubmit(true);

      })

  }

  const callSaveMed = (rowToUpdate,index) => {
    
  
   
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '');

  
  
   const dataToUpdate = {
    status: approve
  };
  
  if (assignId) {
    dataToUpdate.assigned_to = assignId;
  }
  
 
    axios.put(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/${rowToUpdate.id}/`, dataToUpdate, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res => {

        if (res.data.status === "success") {

        
          alert.success("Approved successfully");
          setSearch("")
          setAssignId(0)
          setSelectedAssignees({})
          setMedData([]);
          setRerender(!reRender);
        
          setBackup('')
        }
        else {


          setErrorMsg(res.data.message ? res.data.message : "Error in submission");
          setErrorSubmit(true);

        }



      })
      .catch(err => {

        setErrorMsg("Error in submission");
        setErrorSubmit(true);

      })
    
  
    
  }
  

  const handleCallback = () => {
    medData.splice(0, medData.length + 1)
    getServices1(1, perPage);
  };

  useEffect(()=>{handleCallback()},[props.render,reRender]);

  const handlePageChange1 = (page) => {
    if (hasNext) {
      getServices1(page + 1, perPage);
    }
  };

  const handlePerRowsChange1 = async (newPerPage, pageindex) => {
    setPerPage(newPerPage);
  };

  const getServices1 =  async  (page, per_page) => {

 
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '');



 await   axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=${page}&per_page=${per_page}&timeZone=${currentTimezone}&current_date=${formattedDate}`, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res => {
        if (res.data.status === "success") {
  
         
          setLoading(false);
          let data=res.data.requests
          if (data && data.length > 0) {
            setMedData((prevData) => {
              const newData = data.filter((item) => !prevData.some((existingItem) => existingItem.id === item.id));
              return [...prevData, ...newData];
            });
          
            setHasNext(res.data.has_next);
            setTotalRows(res.data.total_records);}
        }

        else {
          setLoading(false);

          setGetError(res.data.message);
        }



      })
      .catch(err => {
        setLoading(false);

        setGetError("Error in fetching data");
      })
  };
  const handleRender=(e)=>{
    
  
    // setRerender(!reRender)
    setModalShow(false)
  
  setTableData([])
  setMedData([])
  setRerender(!reRender)
  setBackup('')
  // window.location.reload(false)
   
  }

  const AddPopup = (props) => {


    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="remark-width"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">

          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <AddRemark update={handleSend} trackId={trackId} id={id} patient={patient} order={order} render1={handleRender}  />

        </Modal.Body>
       
      </Modal>
    );
  }

  const SuccessPopup = (props) => {


    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">

          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h5 style={{ color: "green" }}>{props.msg} </h5>
        </Modal.Body>
        <Modal.Footer>

          <Button variant="secondary" onClick={props.onHide}>Ok</Button>

        </Modal.Footer>
      </Modal>
    );
  }

  const SubmitErrorPopup = (props) => {


    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 style={{ color: "red" }}> {errorMsg !== '' ? errorMsg : "Error in Data Submission. Please try again!"} </h5>

        </Modal.Body>
        <Modal.Footer>

          <Button variant="secondary" onClick={props.onHide}>Ok</Button>




        </Modal.Footer>
      </Modal>
    );
  }



  const ViewPopup=(props)=>{
    

    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
         backdrop="static"
          keyboard={false}
          dialogClassName="remark-width"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
           
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <ViewInteractions data={remarkData1}  />
  
        </Modal.Body>
        <Modal.Footer>
           
          <Button variant="secondary" onClick={props.onHide}>Close</Button>
         
  
        </Modal.Footer>
      </Modal>
    );
  }

  

  const InfoPopup1 = (props) => {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
     
        </Modal.Header>
        <Modal.Body>
          <div>
          <div className="row-of-features">
               <div className="col-of-features"><br/>               
                 <h6>Medicine Name:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.medicine_name}</span></h6>
                 <h6>Strength:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.strength}</span></h6>
                 <h6>Medicine Type:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.med_type}</span></h6>
                 <h6>Form:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.form.toLowerCase()}</span></h6>
                 <h6>Frequency:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.frequency}</span></h6>
                 <h6>Duration:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.duration}&nbsp;{infoData1.duration_unit} </span></h6>
                 <h6>Intake Period:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.intake}</span></h6>
                 <h6>Intake Count:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.intake_count}</span></h6>
                 <h6>Intake Time:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.intake_time}</span></h6>
                 <h6>Intake Unit:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.intake_unit}</span></h6>
                 <h6>Till_date:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.till_date}</span></h6>
                 <h6>Route:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.route}</span></h6>
                 <h6 style={{textAlign:"left"}}>Remarks:<span>&nbsp;&nbsp;&nbsp;</span><span>{infoData1.remarks}</span></h6>
               </div>
             </div>                  
          </div>
        </Modal.Body>
      </Modal>
    );
  };


  const EditPopup = (props) => {

    return (
      <Modal
        {...props}

        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="remark-width"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditRemark data={remarkData} list={remarkList} update={handleSend} />


        </Modal.Body>
        <Modal.Footer>

          <Button variant="secondary" onClick={props.onHide}>Close</Button>
          <Button className='btn btn-primary btn-col' onClick={props.onSave}>Add</Button>

        </Modal.Footer>
      </Modal>
    );
  }
  const handleAdd = (index, id, trackId, name, order) => {
    
        setCell(index);
        setId(id);
        setTrackingId(trackId)
        setpatient(name)
        setOrder(order)
        setModalShow(true);
      };
    
  const renderRemarks1 = (cellInfo) => {
   
    return (
      <div style={{textAlign:"center"}}>
         <button className="btn btn-primary btn-col btn-square btn-smallest"
        onClick={() => handleAdd(cellInfo.index, medData[cellInfo.index].ref, medData[cellInfo.index].id, medData[cellInfo.index].patient, medData[cellInfo.index].remarks)} ><svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
            <circle cx="19.5" cy="19.5" r="19.5" fill="#2A6379"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5543 7.84269L24.6265 7.86236C25.8289 8.18484 26.7811 8.43954 27.5299 8.71064C28.2961 8.9872 28.9214 9.30312 29.4363 9.78519C30.1856 10.4876 30.7098 11.3964 30.9426 12.3967C31.1033 13.0832 31.0651 13.7828 30.9208 14.5841C30.7819 15.3689 30.5272 16.3211 30.2048 17.5224L29.6188 19.7076C29.2975 20.9089 29.0417 21.8611 28.7717 22.6099C28.494 23.3762 28.1781 24.0014 27.696 24.5163C27.0166 25.2418 26.1432 25.757 25.1796 26.0008C24.8973 26.648 24.4859 27.2309 23.9706 27.7137C23.4557 28.1958 22.8305 28.5117 22.0642 28.7894C21.3154 29.0605 20.3632 29.3152 19.1619 29.6376L19.0887 29.6573C17.8862 29.9787 16.9352 30.2334 16.1503 30.3744C15.349 30.5176 14.6494 30.5559 13.9618 30.3963C12.9617 30.1627 12.0532 29.6377 11.3514 28.8877C10.8705 28.374 10.5534 27.7487 10.2758 26.9824C10.0058 26.2336 9.75108 25.2815 9.42861 24.079L8.84269 21.895C8.5213 20.6925 8.26551 19.7415 8.12559 18.9566C7.98239 18.1553 7.94413 17.4557 8.10373 16.7681C8.33732 15.768 8.8623 14.8595 9.61225 14.1577C10.126 13.6768 10.7513 13.3597 11.5176 13.0821C12.2664 12.8121 13.2185 12.5574 14.4199 12.2349L14.457 12.224L15.278 12.0053C15.7065 10.4761 16.0825 9.39494 16.8171 8.61116C17.519 7.86161 18.4275 7.33702 19.4275 7.10373C20.1151 6.94413 20.8136 6.98239 21.616 7.12559C22.3998 7.26551 23.3519 7.5213 24.5543 7.84269ZM14.7828 13.8353C13.588 14.1555 12.7321 14.3873 12.074 14.6245C11.4072 14.865 11.0169 15.088 10.7327 15.3547C10.2197 15.8349 9.86054 16.4566 9.7008 17.1409C9.61335 17.5213 9.61444 17.9717 9.74015 18.668C9.86586 19.3753 10.1031 20.2607 10.4365 21.5069L11.0027 23.6188C11.3361 24.865 11.5744 25.7504 11.8182 26.4249C12.0587 27.0917 12.2817 27.4831 12.5484 27.7673C13.0286 28.2803 13.6503 28.6395 14.3346 28.7992C14.7139 28.8867 15.1654 28.8845 15.8617 28.7599C16.569 28.6341 17.4544 28.3969 18.7006 28.0635C19.9468 27.729 20.8322 27.4918 21.5078 27.2469C22.1735 27.0065 22.5648 26.7835 22.849 26.5178C22.9999 26.3757 23.1365 26.2227 23.2601 26.0598C23.0573 26.0308 22.8553 25.9962 22.6545 25.956C21.9199 25.8095 21.0366 25.5734 19.949 25.2815L19.8855 25.2651C18.6842 24.9426 17.7321 24.6879 16.9833 24.4168C16.217 24.1403 15.5917 23.8243 15.0768 23.3423C14.3271 22.64 13.8025 21.7312 13.5694 20.7308C13.4098 20.0443 13.4481 19.3447 13.5913 18.5423C13.7312 17.7585 13.987 16.8064 14.3084 15.605L14.7828 13.8353ZM21.3274 8.74015C20.63 8.61444 20.1796 8.61225 19.8003 8.7008C19.1159 8.86054 18.4943 9.21966 18.0141 9.73272C17.5375 10.241 17.2434 11.0281 16.734 12.8952C16.651 13.1991 16.5635 13.5259 16.4684 13.8812L15.9022 15.9931C15.5688 17.2393 15.3315 18.1247 15.2058 18.832C15.0801 19.5283 15.0779 19.9798 15.1665 20.3591C15.3262 21.0434 15.6853 21.6651 16.1984 22.1453C16.4826 22.412 16.874 22.6339 17.5397 22.8755C18.2152 23.1193 19.1007 23.3565 20.3469 23.691C21.4673 23.9916 22.2981 24.2135 22.9737 24.3469C23.6459 24.4813 24.1029 24.5141 24.4767 24.4682C24.5587 24.4573 24.6363 24.4441 24.7128 24.4267C25.3972 24.2669 26.0188 23.9078 26.499 23.3947C26.7658 23.1105 26.9887 22.7192 27.2292 22.0535C27.473 21.3779 27.7102 20.4925 28.0447 19.2463L28.611 17.1343C28.9444 15.8882 29.1816 15.0027 29.3073 14.2955C29.4319 13.5991 29.4352 13.1477 29.3466 12.7684C29.1869 12.084 28.8278 11.4624 28.3147 10.9822C28.0305 10.7154 27.6392 10.4935 26.9734 10.252C26.2968 10.0082 25.4124 9.77098 24.1663 9.43648C22.9201 9.10307 22.0347 8.86586 21.3274 8.74015ZM18.7148 16.3528C18.7427 16.2487 18.7908 16.1512 18.8564 16.0658C18.922 15.9804 19.0038 15.9088 19.0971 15.855C19.1904 15.8012 19.2933 15.7663 19.4001 15.7523C19.5069 15.7383 19.6154 15.7454 19.7194 15.7734L24.9992 17.1879C25.2034 17.2493 25.3757 17.3878 25.4794 17.5741C25.5832 17.7604 25.6103 17.9798 25.5549 18.1857C25.4996 18.3917 25.3662 18.568 25.1831 18.6772C25 18.7864 24.7815 18.82 24.574 18.7708L19.2942 17.3563C19.0843 17.2999 18.9055 17.1625 18.7968 16.9744C18.6882 16.7862 18.6587 16.5626 18.7148 16.3528ZM17.8654 19.5207C17.8933 19.4165 17.9415 19.3189 18.0072 19.2334C18.0728 19.1479 18.1547 19.0762 18.2481 19.0224C18.3415 18.9686 18.4446 18.9337 18.5515 18.9198C18.6584 18.9059 18.767 18.9132 18.8711 18.9413L22.0379 19.7896C22.248 19.8458 22.4271 19.9832 22.5358 20.1715C22.6446 20.3598 22.6741 20.5836 22.6178 20.7936C22.5616 21.0037 22.4242 21.1828 22.2359 21.2915C22.0476 21.4003 21.8238 21.4298 21.6138 21.3735L18.4459 20.5242C18.2361 20.4678 18.0572 20.3305 17.9486 20.1423C17.8399 19.9541 17.8104 19.7306 17.8665 19.5207H17.8654Z" fill="white"/>
            </svg> </button>
     </div>
    );


  }

  const handleApproveAll=(selectedRows)=>{

    // console.log(selectedRows)

    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '');
    const approvedIds = Object.entries(selectedRows)
    .filter(([id, isSelected]) => isSelected)
    .map(([id]) => id);
    const dataToUpdate = {
      approval_ids : approvedIds,
      status : approve,
    
       }

       axios.put(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/`, dataToUpdate, {
        headers: {
  
          "Authorization": 'Token ' + str
        }
      })
        .then(res => {
  
          if (res.data.status === "success") {
          
            alert.success("Approved successfully");
            
            setMedData([]);
            setRerender(!reRender);           

            setBackup('')
          }
          else {
  
  
            setErrorMsg(res.data.message ? res.data.message : "Error in submission");
            setErrorSubmit(true);
  
          }
        })
        .catch(err => {
  
          setErrorMsg("Error in submission");
          setErrorSubmit(true);
  
        })
  }
  const UpdatePopup = (props) => {


    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">

          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h5 style={{ color: "green" }}>Please save to complete changes </h5>




        </Modal.Body>
        <Modal.Footer>

          <Button variant="secondary" onClick={props.onHide}>Ok</Button>






        </Modal.Footer>
      </Modal>
    );
  }

  

  const handleRejectAll=(selectedRows)=>{
   
    // console.log(selectedRows)
    const tokenString = sessionStorage.getItem('usertoken');
    const approvedIds = Object.entries(selectedRows)
    .filter(([id, isSelected]) => isSelected)
    .map(([id]) => id);
    let str = tokenString.replace(/["]+/g, '');
    const dataToUpdate = {
      approval_ids : approvedIds,
      status : reject,
    
       }

       axios.put(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/`, dataToUpdate, {
        headers: {
  
          "Authorization": 'Token ' + str
        }
      })
        .then(res => {
  
          if (res.data.status === "success") {
          
            alert.success("Rejected successfully");
            setTableData([]);
            setRerender(!reRender);
            // setSubmitMsg(res.data.message ? res.data.message : "Updated successfully!");
  
            // setSuccessSubmit(true);
            setBackup('')
          }
          else {
  
  
            setErrorMsg(res.data.message ? res.data.message : "Error in submission");
            setErrorSubmit(true);
  
          }
        })
        .catch(err => {
  
          setErrorMsg("Error in submission");
          setErrorSubmit(true);
  
        })
  }

 

    // Render "Approve" and "Reject" buttons in the header
const renderHeaderButtons = () => {

    const anyRowSelected = Object.values(selectedRows).some((isSelected) => isSelected);
    if (anyRowSelected) {
      // const selectedRowIds = Object.keys(selectedRows).filter((rowId) => selectedRows[id]);
    return (
      <div style={{ display: anyRowSelected ? 'block' : 'none' }}>
      
      <button  style={{borderRadius: "5px",width:"94px",height:"39px",
          background: "#61C65F",color:"white",marginTop:"5%",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
          disabled={!anyRowSelected}
              onClick={() => {handleApproveAll(selectedRows)}} > <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
              <path d="M22 10.46L19.56 7.68L19.9 4L16.29 3.18L14.4 0L11 1.46L7.6 0L5.71 3.18L2.1 3.99L2.44 7.67L0 10.46L2.44 13.24L2.1 16.93L5.71 17.75L7.6 20.93L11 19.46L14.4 20.92L16.29 17.74L19.9 16.92L19.56 13.24L22 10.46ZM9 15.46L5 11.46L6.41 10.05L9 12.63L15.59 6.04L17 7.46L9 15.46Z" fill="white"/>
              </svg> Approve </button> &nbsp;
       
              <button style={{borderRadius: "5px",width:"94px",height:"39px",
        background: "#C6725F",color:"white",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
        disabled={!anyRowSelected}
              onClick={() => {handleRejectAll(selectedRows)}} > <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM14.3 14.3C14.2075 14.3927 14.0976 14.4663 13.9766 14.5164C13.8557 14.5666 13.726 14.5924 13.595 14.5924C13.464 14.5924 13.3343 14.5666 13.2134 14.5164C13.0924 14.4663 12.9825 14.3927 12.89 14.3L10 11.41L7.11 14.3C6.92302 14.487 6.66943 14.592 6.405 14.592C6.14057 14.592 5.88698 14.487 5.7 14.3C5.51302 14.113 5.40798 13.8594 5.40798 13.595C5.40798 13.4641 5.43377 13.3344 5.48387 13.2135C5.53398 13.0925 5.60742 12.9826 5.7 12.89L8.59 10L5.7 7.11C5.51302 6.92302 5.40798 6.66943 5.40798 6.405C5.40798 6.14057 5.51302 5.88698 5.7 5.7C5.88698 5.51302 6.14057 5.40798 6.405 5.40798C6.66943 5.40798 6.92302 5.51302 7.11 5.7L10 8.59L12.89 5.7C12.9826 5.60742 13.0925 5.53398 13.2135 5.48387C13.3344 5.43377 13.4641 5.40798 13.595 5.40798C13.7259 5.40798 13.8556 5.43377 13.9765 5.48387C14.0975 5.53398 14.2074 5.60742 14.3 5.7C14.3926 5.79258 14.466 5.90249 14.5161 6.02346C14.5662 6.14442 14.592 6.27407 14.592 6.405C14.592 6.53593 14.5662 6.66558 14.5161 6.78654C14.466 6.90751 14.3926 7.01742 14.3 7.11L11.41 10L14.3 12.89C14.68 13.27 14.68 13.91 14.3 14.3Z" fill="white"/>
              </svg> &nbsp;Reject </button>
       
      </div>
    );
    }
    else {
      return <div></div>; // Return an empty div if no rows are selected
    }
  };

  const saveChanges1Med = (index) => {
   
    setReject(true);
    const rowToUpdate = medData.filter((elt, i) => {
      return i === index
    })

    callSave1Med(rowToUpdate[0],index);

  }

  

  const [selectedRows, setSelectedRows] = useState([]);
  const [anyRowSelected, setAnyRowSelected] = useState(false);

  useEffect(() => {
    setAnyRowSelected(Object.values(selectedRows).some((value) => value));
  }, [selectedRows]);
 
 
 

  const DispenseAddPopup = (props) => {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="remark-width"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DispenceAdd
            id={dispenceID}
            intake={intakeValue}
          //  submitweight={submitweightHandle}
            seteditDispence={dispenceCount}
            //
            handle={handleCloseDispence}
          />
        </Modal.Body>
       
      </Modal>
    );
  };

  const handleSelectAll1 = (e) => {
    setSearch("")
    setAssignId(0)
    setSelectedAssignees({})
    const checked = e.target.checked;
    const updatedSelectedRows = medData.reduce((acc, row) => {
      acc[row.id] = checked;
      return acc;
    }, {});
    setSelectedRows(updatedSelectedRows);
    setAnyRowSelected(checked);
  };

  const handleInfoPopUp1 = (item) => {

    // setInfoData(item);
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '');



    axios.get(`${APIURL}/api/v1/doctor/patient-prescriptions-detail/${item}/`, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          let data=res.data
 
        setInfoData1(data);
        setinfoShow1(true);
        
        }

   
    else {
     

      setGetError(res.data.message);
    }



  })
  .catch(err => {
   

    setGetError("Error in fetching data");
  })
  
  };
  const handleClose =() =>{
    setDisplayIndex(null)
  }
  const handleSelectAssignee = (assignee, cellInfo) => {
    setSelectedAssignees(prevState => ({
        ...prevState,
        [cellInfo.index]: assignee.name
    }));
    setAssignId(assignee.id)
    setSearch(assignee.name)
    setDisplayIndex(null);
};

const renderAssigned = (cellInfo) => { 
    return (
      <>
          <div style={{ position: 'relative' }}>
              <input
                  className="form-control"
                  placeholder="Search..."
                  value={selectedAssignees[cellInfo.index] !== undefined ? selectedAssignees[cellInfo.index] : ''}
                  onChange={(e) => {setSearch(e.target.value); setSelectedAssignees(prevState => ({
                    ...prevState,
                    [cellInfo.index]: e.target.value
                }));}}
                  onFocus={() => {
                      console.log(cellInfo.index)
                      if (tableData[cellInfo.index]) {
                        tableData[cellInfo.index].flag = true;
                    }
                    
                      const tokenString = sessionStorage.getItem("usertoken");
                      let str = tokenString.replace(/["]+/g, "");
                      axios
                          .get(
                              `${APIURL}/api/v1/service-provider/pharma-fulfil-assignee/?bedunit_code=${cellInfo.original.admit_details}`,
                              {
                                  headers: {
                                      Authorization: "Token " + str,
                                  },
                              }
                          )
                          .then((res) => {
                              if (res.data.status === "success") {
                                  setOptions(res.data.carers);
                                  setOptions1(res.data.carers)
                                  setDisplayIndex(cellInfo.index);
                              }
                              
                          })
                          .catch((err) => {});
                  }}
                  // onBlur={()=> {
                  //   setDisplayIndex(null)
                  // }}
              />
              {displayIndex === cellInfo.index && (
                  <div className="dropdown-menu" style={{}}>
                    <div style={{padding:"5px",textAlign:"right"}}><button style={{backgroundColor:"white"}}onClick={handleClose}><IoClose/></button></div>
                      {options.length>0 ? options.map((assignee) => (
                          <div
                              key={assignee.id}
                              className="dropdown-item"
                              onClick={() => handleSelectAssignee(assignee, cellInfo)}
                          >
                              {assignee.name}
                          </div>
                      )) : <div style={{textAlign:"center"}}>No carer Available</div>}
                  </div>
              )}
          </div>
      </>
  );
};

  const handleRowCheckboxChange = (e, row) => {

    const rowId = row.id;
    const checked = e.target.checked;
  
    setSelectedRows((prevSelectedRows) => {
      // Create a copy of the previous selected rows
      const updatedSelectedRows = { ...prevSelectedRows };
  
      // Update the status of the current row
      updatedSelectedRows[rowId] = checked;
     
  
      return updatedSelectedRows;
    });
  };
  
 
  const renderSelects = (cellInfo) => {
    return (
      <div style={{textAlign:"center"}}>
          {anyRowSelected && (
        <input
          type="checkbox"
          checked={selectedRows[cellInfo.original.id] || false}
          onChange={(e) => handleRowCheckboxChange(e, cellInfo.original)}
        />
      )}
           
          
     </div>
    );


  }

  const renderServiceMedName = (cellInfo) => {

    return (

      <div > <span style={{textTransform: "capitalize" ,textAlign:"center" }}>
        {medData[cellInfo.index][cellInfo.column.id]} <i
              style={{ color: "#75759c", paddingLeft: "5%" }}
              className="fas fa-info-circle fa-sm"
              onClick={() => {
               handleInfoPopUp1(medData[cellInfo.index].request_pid);
              }}
            ></i>
      </span>
    
      </div>

    );
  }
  const handleDispense =(item,id,intake) =>{
    
    setDispenceCount(item);
    setDispenceID(id);
    setIntakeValue(intake)
    setDispenseShow(true);
    
    
    }

    const handleView =(data) => {
 
  
        setRemarkData1(data)
        setViewShow(true)
      }

  const renderDispenceCount =(cellInfo)=>{
    const { interactions } = medData[cellInfo.index];
    return(
      <div > <span style={{textTransform: "capitalize" ,textAlign:"center" }}>
      {medData[cellInfo.index][cellInfo.column.id]} <i
            style={{ color: "#75759c", paddingLeft: "5%" }}
            className="fas fa-pencil-alt"
            onClick={() => {
             handleDispense(medData[cellInfo.index].dispensing_count,medData[cellInfo.index].id,interactions.intake_unit);
            }}
          ></i>
    </span>
  
    </div>
    )
  }

 
  const filterData = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
  let data =[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&request_pid=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);

        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };
  const filterData1 = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
let data=[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&name=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);
        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };
  const filterData2 = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
let data =[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&patient_name=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);
        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };
  const filterData3 = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
let data=[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&doctor_name=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);
        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  const filterData4 = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
  let data =[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&date=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);

        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  const filterData5 = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
  let data =[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&quantity=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);

        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  const filterData6 = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
  let data =[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&nurse_name=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);

        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  const filterData7 = (filterValue) => {
    
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
  let data =[];
    axios.get(`${APIURL}/api/v1/doctor/pharmacy-fulfillment/?type=medicine&status=pending&page=1&per_page=20&timeZone=Asia/Calcutta&current_date=${formattedDate}&bedunit_code=${filterValue}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
    .then(response => {
      if (response.status === 200) {
        setLoading(false);

        data = response.data.requests
        if (data.length>0){
          // if (data && data.length > 0) {
          //   const newData = data.filter((item) => !tableData.some((existingItem) => existingItem.id === item.id));
            setMedData(data);
           }
           else{
            const data1 = data.filter((item) => !medData.some((existingItem) => existingItem.id === item.id));
            setMedData((prevData) => [...prevData, ...data1]);
           }
      setTotalRows(response.data.total_records)
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  };
  const renderService1 = (cellInfo) => {

    return (
     
      <div >  <>
      {/* {cellInfo.column.id === "request_pid"&&props.del.some(element => element === medData[cellInfo.index].id)&& 
      <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">Deleted by doctor</Tooltip>}><svg style={{marginTop:"-5px"}} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="red"><circle cx="12" cy="12" r="9" opacity=".16"/><path d="M12 20a8 8 0 0 1-8-8H2c0 5.523 4.477 10 10 10v-2Zm0-16a8 8 0 0 1 8 8h2c0-5.523-4.477-10-10-10v2Zm-8 8a7.97 7.97 0 0 1 2.343-5.657L4.93 4.93A9.972 9.972 0 0 0 2 12h2Zm2.343-5.657A7.972 7.972 0 0 1 12 4V2a9.972 9.972 0 0 0-7.071 2.929l1.414 1.414Zm-1.414 0l12.728 12.728l1.414-1.414L6.343 4.929L4.93 6.343ZM20 12a7.97 7.97 0 0 1-2.343 5.657l1.414 1.414A9.972 9.972 0 0 0 22 12h-2Zm-2.343 5.657A7.972 7.972 0 0 1 12 20v2a9.972 9.972 0 0 0 7.071-2.929l-1.414-1.414Z"/></g></svg></OverlayTrigger>} */}
      
    
     <span style={{textTransform: "capitalize" ,textAlign:"center" }}>
        {medData[cellInfo.index][cellInfo.column.id]}
        
      </span>
    </>
      </div>

    );
  }



  const renderTableDate = (cellInfo) => {
    const datetimeString = medData[cellInfo.index][cellInfo.column.id];
    const dateParts = datetimeString.split(' ')[0].split('-'); // Split by space and then by hyphen
    const formattedDate = dateParts.join('-'); // Join the date parts with hyphens
  
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "15px" }}>
        {formattedDate}
      </div>
    );
  };
  
  
 
  const columns = [

    {
      Header: "Id",
      accessor: "request_pid",
      Cell: renderService1,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' },

      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      width: 90,
      Filter: ({ filter, onChange }) => (
        // Custom filter input component
     
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),
    },
    {
      Header: "Interactions",
      filterable: true,
      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <i
          style={{ color: "black", marginTop: "9%", width: "10%" }}
          className="fa fa-exclamation-triangle fa-lg"
          aria-hidden="true"
        ></i>
      ),
      width: 80,
      accessor: "interactions", // Assuming that "interactions" is the correct key in your data
      Cell: (props) => {
        const interactionValue = props.value.drug_interactions; // Access "interactions" from the current cell's data
    
        if (interactionValue !== "null" && interactionValue !== "" && interactionValue !== null) {
          return (
            <i
              style={{ color: "black" }}
              onClick={() => handleView(interactionValue)}
              className="fa fa-exclamation-triangle fa-lg"
              aria-hidden="true"
            ></i>
          );
        } else {
          return null; // Or you can return an alternative JSX if needed
        }
      },
    },
    
    {
      Header: "Medicines",
      accessor: "request_items",
      Cell: renderServiceMedName,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' },
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },

      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData1(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),

    },
    {
      Header: "Dispense Count",
      accessor: "dispensing_count",
      Cell: renderDispenceCount,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' },

    
      width: 100,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },

      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData5(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),

    },

    {
      Header: "Date",
      accessor: "date",
      Cell: renderTableDate,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' },
  
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },

      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData4(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),
      width:100
    },
    {
      Header: "Patient",
      accessor: "patient",
      Cell: renderService1,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' },
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },

      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData2(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),

    },
    {
      Header: "Doctor",
      accessor: "doctor",
      Cell: renderService1,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' ,color:"black"},

      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },

      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData3(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),

    },
    {
      Header: "Nurse",
      accessor: "nurse",
      Cell: renderService1,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' ,color:"black"},

      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },

      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData6(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),

    },
    {
      Header: "Ward/Room",
      accessor: "admit_details",
      Cell: renderService1,
      sortable: true,
      filterable: true,
      style: { 'whiteSpace': 'unset' },

      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },

      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input
          value={filter ? filter.value : ''}
          onChange={(e) => {
            const filterValue = e.target.value;
            onChange(filterValue); // Update the filter value
            filterData7(filterValue); // Make an API request and update the filteredData state
          }}
          style={{ color: 'black' }}
        />
      ),

    },


 
    {
      Header: "Assign to ",
      accessor: "assign_to",
      Cell:  renderAssigned,
      style: {
        backgroundColor: "rgba(0,0,0,0.1)",
        color:"black"
      },
      width:170,
      sortable: true,
     
      show:!anyRowSelected,
   
    },

  

    {
      Header: () => (
        <div>
          <div style={{fontSize:"8px"}}>Select All</div>
          
        </div>
      ),
    // Replace 'columnName' with your actual column name
      width: 60,
      filterable: true,
      Filter: ({ filter, onChange }) => (
        // Custom filter input component
        <input type="checkbox"
        checked={anyRowSelected}
          onClick={(e) =>handleSelectAll1(e) }
          style={{ color: 'black', width: '20px',
          height: '20px', }} // Set the text color of the input field here
        />
      ),
      Cell: renderSelects,
      show: page === 1,
   
    },
  
 
    {
      
      Cell:  ({ index }) => ( <button  style={{borderRadius: "5px",width:"94px",height:"39px",
        background: "#61C65F",color:"white",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
     
            onClick={() => {saveChangesMed(index)  }} >
               <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
            <path d="M22 10.46L19.56 7.68L19.9 4L16.29 3.18L14.4 0L11 1.46L7.6 0L5.71 3.18L2.1 3.99L2.44 7.67L0 10.46L2.44 13.24L2.1 16.93L5.71 17.75L7.6 20.93L11 19.46L14.4 20.92L16.29 17.74L19.9 16.92L19.56 13.24L22 10.46ZM9 15.46L5 11.46L6.41 10.05L9 12.63L15.59 6.04L17 7.46L9 15.46Z" fill="white"/>
            </svg> &nbsp;&nbsp; Approve </button>) ,
        
      
   
      sortable: false,
      filterable: false,
      minWidth: 50,
      width: 120,
      show: !anyRowSelected,
      
    },


    {
      
      Cell: ({ index }) => (  <button style={{borderRadius: "5px",width:"94px",height:"39px",
      background: "#C6725F",color:"white",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
    
            onClick={() => {saveChanges1Med(index)  }} > <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM14.3 14.3C14.2075 14.3927 14.0976 14.4663 13.9766 14.5164C13.8557 14.5666 13.726 14.5924 13.595 14.5924C13.464 14.5924 13.3343 14.5666 13.2134 14.5164C13.0924 14.4663 12.9825 14.3927 12.89 14.3L10 11.41L7.11 14.3C6.92302 14.487 6.66943 14.592 6.405 14.592C6.14057 14.592 5.88698 14.487 5.7 14.3C5.51302 14.113 5.40798 13.8594 5.40798 13.595C5.40798 13.4641 5.43377 13.3344 5.48387 13.2135C5.53398 13.0925 5.60742 12.9826 5.7 12.89L8.59 10L5.7 7.11C5.51302 6.92302 5.40798 6.66943 5.40798 6.405C5.40798 6.14057 5.51302 5.88698 5.7 5.7C5.88698 5.51302 6.14057 5.40798 6.405 5.40798C6.66943 5.40798 6.92302 5.51302 7.11 5.7L10 8.59L12.89 5.7C12.9826 5.60742 13.0925 5.53398 13.2135 5.48387C13.3344 5.43377 13.4641 5.40798 13.595 5.40798C13.7259 5.40798 13.8556 5.43377 13.9765 5.48387C14.0975 5.53398 14.2074 5.60742 14.3 5.7C14.3926 5.79258 14.466 5.90249 14.5161 6.02346C14.5662 6.14442 14.592 6.27407 14.592 6.405C14.592 6.53593 14.5662 6.66558 14.5161 6.78654C14.466 6.90751 14.3926 7.01742 14.3 7.11L11.41 10L14.3 12.89C14.68 13.27 14.68 13.91 14.3 14.3Z" fill="white"/>
            </svg> &nbsp;&nbsp;Reject </button>) 
        
    ,
    
      sortable: false,
      filterable: false,
      minWidth: 50,
      width: 120,
      show: !anyRowSelected,
    },
    { 
      Header: renderHeaderButtons,
      filterable: false,
      sortable: false,
      minWidth: 50,
      width: 250,
      show: anyRowSelected,
    },
    {
      Header: "",
     
      Cell: renderRemarks1,
      
     
      sortable: false,
      filterable: false,
      minWidth: 50,
      width: 120
    },
  ]

  const handlePageChange = (pageIndex) => {
    const nextPage = pageIndex + 1; // Convert 0-based index to 1-based page number
    if (pageIndex >= 0 && nextPage <= Math.ceil(totalRows / perPage)) {
      setPage(nextPage);
      getServices1(nextPage, perPage); // Fetch data for the new page
    }
  };

  const displayTable =  
  <ReactTable
  data={medData}
  columns={columns}
  resizable
  className="service-req-table"
  defaultPageSize={perPage}
  showPagination={tableData.length>0}
  pages={Math.ceil(totalRows / perPage)}
  page={page-1}
  onPageChange={(pageIndex) => { handlePageChange(pageIndex); }}
  onPageSizeChange={(newPerPage) => { setPerPage(newPerPage); setPage(0); }}
  pageSizeOptions={[5, 10, 20, 50, totalRows]}
/>
//   <ReactTable
//   columns={columns}
//   data={medData}
//   className="service-req-table"
//   resizable
//   defaultPageSize={perPage}
//   minRows={perPage - 1}
//   style={{ textAlign: "center" }}
//   pageSizeOptions={[ perPage,20, 50,Math.ceil(totalRows / 2),totalRows]}
//   //pageSizeOptions={[perPage - 1,10,totalRows]}
//   pages={Math.ceil(totalRows / perPage)}
//   showPagination={medData.length > 0} // Hide pagination if no data
//   showPaginationNext={medData.length > 0 && page < totalRows} // Show "Next" button if there is more data
//   onPageChange={(pageIndex) => { handlePageChange1(pageIndex); }}
//   onPageSizeChange={handlePerRowsChange1}
//   //pages={totalRows} // Specify the total number of pages
// />  
  
  
  return(
        <>

{displayTable}




{
        modalShow ?
          <AddPopup
            show={modalShow}
            onHide={() => {
              setModalShow(false);
            }}
          /> : null
      }

{
      viewShow ? 
      <ViewPopup
        show={viewShow}
        onHide= {() => { setViewShow(false)     
        }}
      /> : null
    }


{infoShow1 ? (
        <InfoPopup1
          show={infoShow1}
          onHide={() => {
            setinfoShow1(false);
          }}
        />
      ) : (
        ""
      )}
      {
        editShow ?
          <EditPopup
            show={editShow}
            onHide={() => {
              setEditShow(false)
            }}
            onSave={() => {
              if (sendData !== tableData[cell].remarks) {
                const data = tableData
                data[cell].remarks = sendData
                setTableData(data)
                setBackup(sendData)
                setEditShow(false);
                setRender(!render);
                setUpdateSuccess(true)

              }
            }} /> : null
      }

{dispenseShow ? (
          <DispenseAddPopup
            show={dispenseShow}
            seteditDispence={dispenceCount}
            onHide={() => {
              setDispenseShow(false);
            }}
          />
        ) : null}

      {
        updateSuccess ?
          <UpdatePopup
            show={updateSuccess}
            onHide={() => {
              setUpdateSuccess(false);
            }}
          /> : null
      }
   
        </>
    )
}
export default Medicines